export default {
    tms: {

    },
    generic: {
        Home:"主页面",
        ReporMaster: "Report Master",
        GenericName: "Generic Name",
        ModuleCode: "模块编码",
        Description: "描述",
        FunctionCode: "功能编码",
        PageTitleCode: "页标题编号",
        IsPaging: "是否分页",
        IgnoreCount: "上/下页",
        Creator: "创建人",
        CreateDate: "创建日期",
        Modifier: "修改人",
        ModifyDate: "修改日期",
        GMCUID: "GMC UID",
        SCHEMAUID: "SCHEMA UID",
        UIAction: "UI Action",
        Validation: "验证",
        Editable: "编辑",
        EditCondition:"编辑条件",
        Searchable: "查询",
        DefaultValue: "默认值",
        Madatory: "必填",
        Displayable: "显示",
        Sequence: "序列",
        Condition: "条件",
        Mandatory: "必填",
        AndOr: "并且/或者",
        GCDUID: "GCD UID",
        ParentGCDUID: "父 GCD UID",
        IfOrNotMove:"是否需要移库操作?",
        TableName: "表名",
        EnglishName: "英文名称",
        CnName: "中文名称",
        TraditionalCNName: "繁体中文名称",
        KorName: "韩语名称",
        thName: "泰语名称",
        jpName: "日语名称",
        Header: "主信息",
        TableAlias: "表别名",
        FieldName: "字段名",
        FieldType: "字段类型",
        FieldLength: "字段长度",
        FieldLengthDecimal: "字段长度小数位",
        ForeignTable: "Foreign 表",
        ForeignFIELD: "Foreign 字段",
        LanguageCode: "语言编码",
        Module: "模块",
        SubPage: "子页面",
        SubModule: "子模块",
        Function: "功能",
        PageTitle: "页主题",
        Decimal: "小数位",
        Edit: "编辑",
        Add: "添加",
        More: "更多",
        AreyoudeleTask: "确定要删除所选记录吗",
        Yes: "是",
        No: "否",
        Delete: "删除",
        Zip: "压缩Zip",
        Up: "上",
        Down: "下",
        Store: "存储",
        ButtonGroupName: "按钮分组名",
        Apply: "应用",
        Configuration: "配置",
        Name: "名",
        RenderType: "渲染类型",
        Type: "类型",
        Code: "编码",
        ViewType: "视图类型",
        PatternType: "模式类型",
        ExtenalAPI: "外部 API",
        MapToModule: "模块映射",
        FieldMap: "字段映射",
        BehaviorPattern: "行为模式",
        Parameters: "参数",
        CustPage: "CustPage",
        Action: "行为",
        Width: "宽",
        ConsParameter: "Cons. 参数",
        Constrainttable: "约束表",
        Seq: "序列",
        ValidationSQL: "校验SQL",
        operate: "操作",
        Group: "分组",
        FKTable: "外键表",
        FKFieldName: "外键名",
        SQLParameters: "SQL 参数",
        defaultValue: "默认值",
        DisplayColumns: "显示列",
        SortSeq: "排序序列",
        OrderBy: "以..排序",
        Refresh: "刷新",
        PagePropertyGroupName: "页面属性组名",
        Disaplyable: "显示",
        Like: "模糊",
        IsShowTitle: "是否标题",
        ShowTitleSeq: "显示标题序列",
        OptionType: "选择类型",
        ExtentionValue: "延伸值",
        GenIdtype: "Gen Id type",
        Hyperlink: "超链接",
        Isitunique: "是否唯一",
        Statistics: "统计",
        DataFormat: "数据格式",
        FieldPattern: "字段样式",
        GenericParameters: "配置参数",
        DefaultSelected: "默认选择",
        IsReserveAdmin: "是否储备管理",
        TitleInfo: "标题信息",
        UniqueParameter: "唯一参数",
        Depend: "依赖",
        IsDefType: "IsDefType",
        ConfigurationMethod: "配置的计算方法",
        CalcParameters: "计算参数",
        CalcType: "计算类型",
        SurfixParameter: "后缀参数",
        ComputationalEvent: "计算事件",
        TriggerFields: "触发字段",
        IsTrigger: "是否触发器",
        Publish: "发布",
        AdvanceSearch: "高级查询",
        SearchTemplate: "过滤模板",
        IsDefault: "是否默认",
        Loadable: "可加载",
        IsExtra: "是否额外",
        ExtraParameters: "额外参数",
        TemplateName: "模板名称",
        CreateTime: "创建时间",
        Copy: "复制",
        CreateGenericData: "新建基础数据",
        AppendGenericData: "附加基础数据",
        DeleteGenericData: "删除基础数据",
        PleasemoduleonlyGeneric: "请确保一个模块只有一个基础数据启动",
        DBSchema: "DB Schema",
        PageProperty: "页面属性",
        SQL: "SQL",
        ConfigSQL: "配置 SQL",
        Behavior: "行为",
        ForOption: "可选",
        StartupModule: "启动模块",
        UseViewSQL: "使用视图SQL",
        ReportView: "报表视图",
        TableViewName: "表/视图 名",
        FiledName: "字段名",
        Basic: "基础",
        AliasName: "别名",
        SubModuleCode: "子模块编码",
        SubModuleName: "子模块名称",
        FunctionName: "功能名",
        FunctionLevel: "功能级别",
        ParentFunctionCode: "父功能编码",
        FunctionSeq: "功能序列号",
        FunctionURL: "功能 URL",
        LangCode: "语言",
        Menu: "菜单",
        GenericMenu: "Generic 菜单",
        RelationTable: "关联表",
        UserMenu: "用户菜单",
        FunctionAPI: "功能 API",
        Status: "状态",
        NotInactive: "不允许发布已经发布或者不启用的配置",
        Mapto: "映射给",
        Project: "项目",
        Usage: "作用",
        Source: "来源",
        TargetTo: "目标纸箱",
        ExcelType: "Excel 类型",
        OnlyAllowLetter: "只允许输入字母",
        Export: "导出",
        SourceMap: "源程序映射",
        MapToView: "映射到视图",
        TargetMap: "目标印射",
        Excel: "Excel",
        SelectedMatched: "所选列需要匹配.",
        DataDuplication: "数据重复",
        UnUploadFile: "请上传文件！",
        isShowCopy:"复制",
        copySuccess:"复制成功",
        totalOf:"共 ",
        Records:"条记录",
    },
    userlang: {
        Address1: "地址1",
        Address2: "地址2",
        Address3: "地址3",
        Address4: "地址4",
        Postal: "邮编",
        Street: "街道",
        District: "区",
        Latitude: "维度",
        Longitude: "经度",
        Country: "国家",
        Enable: "可用",
        Disable: "不可用",
        Empower: "授权",
        Edit: "编辑",
        EditUser: "编辑用户",
        UserAccount: "用户账号",
        LoginAccount: "用户账号",
        DispName:"用户名称",
        Email: "邮箱",
        EmailInfoFrom: "输入的邮箱不合法!",
        FirstName: "名",
        MiddleName: "中间名",
        LastName: "姓",
        DisplayName: "显示名",
        Title: "标题",
        Gender: "性别",
        Male: "男",
        Female: "女",
        Company: "公司",
        Department: "部门",
        Position: "职位",
        Telephone: "电话",
        City: "城市",
        SelectCity: "请选择城市",
        TimeZone: "时区",
        english:"英语",
        englishName:"英语名字",
        sumplifiedName:"简体中文名字",
        traditionalName:"繁体中文名字",
        koreanName:"韩语名字",
        japaneseName:"日语名字",
        thaiName:"泰语名字",
        Language: "语言",
        Jtlang: "简体中文",
        korlang: "한국어",
        thlang: "ภาษาไทย",
        jplang: "日本語",
        ftlang: "繁体中文",
        Orgnization: "组织",
        Project: "项目",
        Delete: "删除",
        NorecordFound: "未找到记录",
        Organization: "组织",
        Warehouse: "仓库",
        WarehouseName: "仓库名称",
        Address: "地址",
        Save: "保存",
        AccessRights: "访问权限",
        Pleaseselect: "请选择",
        Role: "角色",
        PleaseOneleast: "请最少选择一条记录.",
        SaveSuccessfully: "保存成功",
        AddProject: "添加项目",
        AddWarehouse: "添加仓库",
        defaultOrg:"默认组织",
        defaultProj:"默认项目",
        domain:"域",
        useredQr:"2FA 用户QR"
    },
    convertCountResult: {
        title: "转换盘点结果",
        filenameStartFrom: "文件名起始字符",
        importSuccess: "导入成功",
        pleaseUpload: "请上传文件",
        noFileToDownload: "暂无可下载的文件",
        invalidFilename: "文件名起始字符必须为 2、S 或 Q",
        invalidFileType: "仅支持上传 .xlsx 格式的文件"
    },
    publicLang: {
        DeleteSuccess: "删除成功",
        HelpMessage: "帮助",
        PreviousPage: "上一页",
        NextPage: "下一页",
        Page: "页",
        CourierNumberIsNotNull: "快递单号不能为空",
		CourierNumber:"快递单号",
        InputRequiredValue: "请先填写必填项!",
        containerIdNotExists: "箱号不存在或已经收货",
        CartonIdNumNotExists: "箱号不存在或已经收货",
        PleaseOneLeast: "请最少选择一条记录.",
        AreUpadte: "是否更新所选记录?",
        NotAllowtodeleteCancel: "不允许删除/取消",
        Notprintfirst: "不允许打印, 请先做分配.",
        Notprintpackfirst: "不允许打印, 请先扫描装箱.",
        ProjectandWarehouse: "项目 和 仓库",
        AlertMessage: "弹出信息",
        NewTemplateName: "新模板名称",
        ProjectTemplate: "项目模板",
        StyleSetting: "样式设置",
        NavigationMode: "导航模式",
        LeftLayout: "左侧菜单布局",
        TopLayout: "顶部菜单布局",
        Arecancel: "请确认是否删除?",
        Areconfirm: "请确认是否提交?",
        Yes: "是",
        No: "否",
        SKUSearch: "商品查询",
        StatusNotNew:"订单状态不能是新建状态",
        PubOk: "OK",
        theIstAdministrator: "当前用户还没有分配权限,请联系管理员.",
        PleaseSltAtleast: "请最少选择一条记录.",
        ColumnSearchRequired: "请先设置查询条件后再加载数据.",
        PleaseCheckDisplayableFirst: "请先检查可显示内容！",
        pleaseOneOnly: "请只选择一条记录.",
        SelectRestrict: "选择数据的数目不允许超100行",
        PleaseFirst: "请选择一条记录.",
        DraglistSort: "拖动列表以进行排序",
        CreatTime: "创建时间",
        Clear: "清除",
        Save: "保存",
        UpdateSuccess: "更新成功",
        PasswordUpdatedSuccessfully: "密码成功更新!",
        Project: "项目",
        PleaseSelect: "请选择",
        Required: "必须的",
        ThenotEmail: "输入的邮箱不合法",
        PleaseEnter: "请输入",
        PleaseMobileNumberCorrectly: "请输入正确的电话号码",
        RequireNumerFormat: "请输入数字格式",
        SystemAdministrator: "系统配置错误，请联系管理员.",
        Download: "下载",
        Preview: "预览",
        Wrongconfiguration: "配置错误",
        NotAllowToOverReceive: "不允许超收",
        Search: "查询",
        Close: "关闭",
        sendEdi: "发送Edi",
        rePrint: "预打印",
        Cancel: "取消",
        Confirm: "确认",
        CheckComplete: "复核完成",
        CancelCheckComplete: "取消复核完成",
        Template: "模板",
        Loading: "装车",
        notExistScanInList: "{0} 不存在入库扫描列表中",
        prompt: "提示", // 提示
        closePrompt:"是否确认关闭订单？",
        cancelPrompt: "确认取消订单? 该操作不可逆转。",
        IncorrectConfiguration: "配置错误",
        NoreportFound: "没有找到报表",
        PleaseinputEmail: "请输入邮箱!",
        Upload: "上传",
        UploadPhoto: "上传图片",
        UploadSuccess: "上传成功!",
        DownloadCenter: "下载中心",
        FileName: "文件名",
        Action: "功能",
        overScanMsg:"{0} 不允许超收",
        overRemoveMsg:"{0} 不允许过量删除",
        locationIsNull:"库位不能为空",
        ConfirmShipment: "确定发运?",
        LastSKUCheckCompletePrompt:"订单装箱完成，请复核.",
        statusError:"{0} 状态错误",
        waveIdIsNotEmpty:"{0} 订单已经存在波次号",
        UploadFileOverSize:"上传的文件超过了大小限制，请检查.",
        UploadFailed: "上传失败",
        DownloadFailed: "下载失败",
        cardNeedReplace:"需更换卡片",
        NoPickedStockInContainer:"这个集装箱没有拣货!",
        needToHangGooseDownGoldMedal:"需挂鹅绒金牌",
        requestApproval:"申请审批",
        cancelRequest:"取消申请",
        MustBeGreaterThanZero: "{0} 必须大于0"
    },
    roleGe: {
        RoleLevel: "角色级别",
        ModuleName: "模块名",
        SubModuleName: "子模块名",
        Add: "添加",
        Delete: "删除",
        Edit: "编辑",
        EditRole: "编辑角色",
        CreateRole: "新建角色",
        RoleName: "角色名",
        RoleType: "角色类型",
        PleaseSelect: "请选择",
        Description: "描述",
        Save: "保存",
        pleaseOneOnly: "请选择一条记录",
        SaveuSccessfully: "保存成功",
        RuleType: "规则类型",
        RuleName: "规则名",
        Organization: "组织",
        Project: "项目",
        Search: "查询",
        Creator: "创建人",
        CreateTime: "创建时间",
        Modifier: "修改人",
        ModifiyTime: "修改时间",
        Next: "下一个",
        SortSubmit: "顺序提交",
        Inventory: "库存",
        TableName: "表名",
        FieldName: "字段名",
        InventoryFieldName: "库存字段名",
        FieldType: "字段类型",
        Condition: "条件",
        CustomizeValue: "自定义值",
        OrderBy: "以..排序",
        Operation: "操作",
        SO: "订单",
        Rule: "规则",
        Grouping: "分组",
        GroupingAndOrderBy: "分组和排序",
        ReportSetting: "报表设置",
        Import: "导入",
        Lookup: "查找",
        ReportName: "报表名",
        ConfigEnableUser: "配置可用用户"
    },
    menu: {
        NotificationList: "通知列表",
        Read: "已读",
        Unread: "未读",
        ViewMore: "查看更多",
        YouhaveViewedNotifications: "您已经查看了所有通知列表.",
        Receiver: "接收者",
        ReadTime: "可读时间",
        Status: "状态",
        Subject: "主题",
        RefType: "参考编号类型",
        RefNum: "参考编号",
        StartTime: "开始时间",
        CompleteTime: "完成时间",
        FirstName: "名",
        LastName: "姓",
        DisplayName: "显示名",
        MiddleName: "中间名",
        Email: "邮箱",
        Title: "标题",
        Gender: "性别",
        Male: "男",
        Female: "女",
        Department: "部门",
        Position: "职位",
        Telephone: "电话",
        City: "城市",
        TimeZone: "时区",
        DefaultLanguage: "默认语言",
        PerformanceFeedback: "绩效反馈",
        SimulateUser: "模拟用户",
        ReleaseUser: "发布用户",
        PrintNode: "打印节点",
        Logout: "退出",
        NoRecordfound:"未找到记录"
    },
    easyCron: {
        Specify: "说明",
        NoSet: "No Set",
        OnlyDaysWeeksSet: "只能设置其中的一天和一个星期",
        Perday: "每天",
        Between: "两者之间",
        Day: "天",
        to: "到",
        PreHour: "每小时",
        Hour: "小时",
        From: "从",
        PerMinute: "每分钟",
        Minute: "分钟",
        PerYear: "每年",
        Year: "年",
        Start: "开始",
        Expire: "过期",
        dayWeekNoset: "请定义天或星期",
    },
    pubGicSet: {
        EachGroupRow: "每单行数",
        SplitRec: "拆分收货单",
        SelectSKU: "选择SKU",
        SelectOneSKU:"请选择一个SKU",
        QuantityTypeError: "扫描数量类型错误",
        soQty: "订单数量",
        OrderType: "订单类型",
        SelectFieldName: "选择字段名",
        SkuDesc: "商品描述",
        WarehouseCode: "仓库编号",
        NoRecordfound: "没有找到记录!",
        DragTheListTosort: "拖动列表以进行排序",
        AdvanceSearch: "高级查询",
        AdvanceSort: "高级排序",
        FreezeCol: "冻结 Col",
        Clear: "清除",
        Sort: "排序",
        Search: "查询",
        FieldName: "字段名",
        OrderBy: "以..排序",
        Name: "名称",
        PleaseName: "请输入名称",
        SearchTemplate: "过滤模板",
        AdvanceSearcheTemplate: "高级查询模板",
        AreyoudeleTask: "确定要删除所选记录吗?",
        UserResetChanges: "以下操作將會把這用戶已修改的權限清除, 請確認是否繼續執行?",
        ResetPasswordsConfirm: "密码将被重置为NULL，请确认是否继续?",
        ResetPasswordsButton: "重置密码",
        InvalidSKU: "SKU {0} 无效.",
        NotEnoughQtyPack: "{0} 不允许过量装箱",
        NotEnoughQtyCancelPack: "{0} 不允许过量取消装箱",
        CartonClose:"{0} 已关箱.",
        UnpackedErrorWithEmptyCarton: "{0} 空箱不能再取消了.",
        NotAllowOverPack: "{0} 不允许超量打包.",
        ScanPackDecodeError:"扫描条码格式错误.",
        NotEnoughSkuRemoved: "箱子没有足够{0}的数量.",
        unscanpackDataNotCancel: "未扫描打包的数据无法取消",
        cartonQtyTooLarge: "箱子数量过大",
        Yes: "是",
        No: "否",
        delete: "删除",
        PleaseTamplateNameFirst: "请先选择模板名称",
        SaveSuccess: "保存成功",
        Mandatory: "必填",
        Pleaseselect: "请选择",
        SelectPicture: " 请选择一张图片",
        Split: "分割",
        FromValue: "From Value",
        ToValue: "To Value",
        NotAllowToSplit: "不允许分单",
        PleaseSelectFieldName: "请选择字段名称",
        FieldAddedRepeatedly: "字段名不能重复添加",
        ToLocationRequired: "目标库位必填",
        QtyRequired: "数量必填",
        qtyTolocatioRequired: "目标库位数量必填",
        PleaseCheckTheData: "请检查数据",
        ToValueCannotBeEmpty:"To value 不能为空",
        RecQty: "收货数量",
        Location: "库位",
        ToLocation: "目标库位",
        LocationISrequired: "库位必填",
        NewContainer: "新货柜",
        LoadedCartonQty: "已装车箱子数量",
        ContainerNo: "装车号",
        SSCC: "箱号/快递单号",
        trackingNo: "快递单号",
        SSCC1: "箱号",
        lockUpSSCC: "锁住箱号",
        AmrContainerNo:"AMR 周转箱号",
        iWmsContainerNo:"iWMS 周转箱号",
        HiddenTable: "隐藏表单",
        logisticsid: "快递单号",
        RemoveCartonFromContainer: "从货柜中取出纸箱",
        RelID: "订单号码",
        PackID: "打包 ID",
        Carton: "箱号#",
        SKUQty: "商品数量",
        NewPallet: "新托盘",
        PalletNo: "托盘号",
        WeightPallet:"托盘重量",
        Length: "长",
        InputaNumber: "请输入数字",
        Width: "宽",
        Height: "高",
        CBM: "体积",
        Weight: "重量",
        WeightUOM: "重量单位",
        LoadedPalletQty: "已装车托盘数量",
        RemovePalletfromContainer: "请从货柜移除托盘",
        Remarks: "备注",
        Desc:"详情",
        SKU: "商品",
        LogicalWH: "Logical WH",
        LotID: "批次 ID",
        AvailableQty: "可用数量",
        AdjustQty: "调整数量",
        ReasonCode: "调整原因",
        Action: "加或减",
        Adjust: "调整",
        NotEnoughInventoryToAdjust:"没有足够库存调整",
        ActionCannotBeEmpty: "加或减 不允许为空",
        ToLocationCannotBeEmpty: "目标库位不允许为空",
        ToSkuCannotBeEmpty: "目标商品不允许为空",
        NotEnoughInventoryToMove : "没有足够库存转移",
        DataNotChange: "数据未发生改变，无需保存",
        DataModifyNotSave: "修改后的数据未保存",
        BatchUpdateShipment: "批量更新发运",
        BathUpdate: "批量更新",
        BatchUpdate: "批量更新",
        ButtonConfig: "按钮配置",
        ButtonConfigName: "按钮配置名称",
        BePrint: "BePrint",
        ActionValue: "Action Value",
        DeAllocation: "取消分配",
        BatchNo: "生产批号",
        Qty: "数量",
        originalLotId: "源批次 ID",
        soLineSeq: "订单行序列",
        PickLineSeq: "拣货行序列",
        ModifyTime: "修改时间",
        ShipOutDate: "出单日期",
        GenerateLocation: "库位生成",
        RowName: "行名称",
        ColumnInRow: "列的行",
        LevelInRow: "Level in Row",
        BinsinLocation: "Bins in Location",
        CartonToContainer: "箱子到货柜",
        CartonToPallet: "箱子到托盘",
        PalletToContainer: "托盘到货柜",
        Error: "错误",
        Lookup: "查找",
        PrePrintLPN: "Pre-Print LPN",
        NumberOfLPNLabelRequired: "LPN 标签号必填",
        Print: "打印",
        ReprintLPN: "预打印 LPN",
        Lpn:"LPN",
        Reprint: "预打印",
        LastPrinted: "最后打印",
        MoveLogic: "移库逻辑",
        Reason:"Reason",
        FromLocation: "原始库位",
        MoveQty: "移库数量",
        ColumnName: "字段名",
        printReportColumn: "打印报表字段名",
        ScanIn: "入库扫描",
        RecID: "订单号码",
        CartonID:"纸箱 ID",
        TraceID:"跟踪 ID",
        ContainerId:"周转箱",
        CartonIdNum: "箱号",
        DeleteCartonID:"删除箱号",
        CartonIdQty:"箱号数量",
        CartonIdNumRegExp:"箱号正则表达式错误",
        CartonIdNumFormatError:"错误箱号# {0} , 请重新扫描",
        ContainerIdIsEmpty:"周转箱必填",
        EPC:"防伪码",
        EPCIsEmpty:"防伪码必填",
        EPCFormatError:"防伪码异常,请重新识别",
        EpcQtyMustBeOne:"防伪码只能单件扫描",
        SSCCIsEmpty:"箱号必填",
        cartonTypeIsEmpty:"箱子类型必选",
        ConvertToReceive:"转换为接收",
        CancelGR: "取消GR",
        NewGR: "新 GR",
        Descr: "描述",
        ASNQty: "预收货数量",
        OutstandingQty: "未扫描数量",
        ContainerIdQty: "周转箱数量",
        ScanAction: "扫描事件",
        RemoveSku:"删除",
        addSku:"增加",
        StockStatus: "库存状态",
        LockScanQty: "锁住扫描数量",
        LockContainer: "删除箱号",
        NoofSKU: "商品种类",
        NoofCartonID: "纸箱编号",
        UOM: "体积",
        ScanPack: "扫描装箱",
        WaveID: "波次 ID",
        CancelPack: "取消装箱",
        PrintPackingList: "打印拣货单",
        PackingList: "打印装箱单",
        AllocatedQty: "分配数量",
        PackedQty: "打包数量",
        PackedQty2: "打包数量",
        RemoveScanItem: "删除扫描项目",
        IsCarton: "箱子扫描",
        ScanInDirectly:"直接扫描",
        IsPrePack: "Is Pre-Pack",
        IsTraceId: "Is Trace Id",
        UnpackQty: "未打包数量",
        Detail: "明细",
        Percentage: "百分比",
        NoofCarton: "纸箱编号",
        Createdby: "创建人",
        CloseAndNew: "关闭 和 新建",
        New: "新建",
        Remove: "移除",
        Append: "追加",
        ImportScanningFile: "导入扫描文件",
        ImportSacnningFileGroupName: "导入扫描文件",
        PrintSSCC: "打印箱贴",
        PrintCarton: "打印箱贴",
        CartonNoSSCC: "Carton No./SSCC",
        ScannedQty: "扫描数量",
        CartonNo: "纸箱编号",
        CartonType: "箱子类型",
        DimUOM: "体积单位",
        GrossWeight: "毛重",
        NetWeight: "净重",
        PleaseNewOneCartonFirst: "请先生成一个纸箱",
        Nosscc: "缺失SSCC, 请输入扫描所需SSCC",
        CancelTransit: "取消发运",
        Transit: "发运",
        Step: "步骤",
        FromQty: "原始数量",
        ToQty: "目标数量",
        ToSku: "目标商品",
        FromSku: "原始商品",
        CourierEdi: "Courier EDI",
        IntersoftGenerateLabel: "Intersoft Generate Label",
        IntersoftCancelLabel: "Intersoft Cancel Label",
        IntersoftGenerateMainfest: "Intersoft Generate Mainfest",
        exportPackageData: "导出装箱数据",
        orderCheckCompleteStartTime: "订单复核开始时间",
        orderCheckCompleteEndTime: "订单复核结束时间",
        whetherToPrintOnlyCompletedOrders: "是否只打印已复核订单",
        addSoToWave:"订单关联波次",
        waveId:"波次ID",
        ref01:"参考编码01",
        ref02:"参考编码02",
        ref03:"参考编码03",
        ref04:"参考编码04",
        ref05:"参考编码05",
        query:"查询",
        reset:"重置",
        save:"保存",
        gift:"赠品",
        notGiftScanAntiCode:"非赠品，需扫描防伪码.",
        searchCartonByWave:"波次查询箱号",
        importSscc:"导入箱号",
        pleaseScanAntiCode:"请扫描防伪码"
    },
    manual: {
        Manual: "手动",
        New: "新建",
        AddToPick: "添加到拣货",
        Unpick: "取消拣货",
        SO: "订单编号",
        Sku: "商品",
        RecID: "订单号码",
        BatchNo: "批号",
        SODate: "订单日期",
        AllQty: "分配数量/订单数量y",
        AllocateLocation: "分配库位",
        Status: "状态",
        LotID: "批次 ID",
        RecDate: "收货日期",
        RecQty: "收货数量",
        AvailableQty: "可用数量",
        AllocateQty: "分配数量",
        ShippedQty: "发运数量",
        MANUFACTUREDate: "加工日期",
        EXPIRYDate: "有效期",
        SHELFDate: "上架日期",
        NewpickPleasego: "创建新的拣货单并继续"
    },
    login: {
        SignAccount: "用您现有的帐户登录",
        loginTitle1: "欢迎回来",
        loginTitle2: "请登录您的帐户",
        loginTitle3: "两步骤验登",
        loginTitle4: "这个额外步骤可证明当前登录账号的确实是你本人",
        loginTitle5:"通过以下电话号码接收验证码：**** **",
        loginTitle6:"",
        loginTitle7:"需支付",
        loginTitle8:"一般通讯费用",
        loginTitle9:"通过电邮接收验证码",
        loginTitle10:"验证码",
        loginTitle11:"请输入验证码",
        loginTitle12:"是否信任此浏览器？",
        loginTitle13:"您仍然需要密码才能登入网站，但下次登入时，不会再要求您输入验证码。(未来",
        loginTitle27:"天)",
        loginTitle14:"透过Google或Microsoft Authenticator",
        loginTitle15:"等应用程序取得验证码",
        loginTitle16:"设置",
        loginTitle17:"取消设置",
        loginTitle18:"安装您选择的TOTP",
        loginTitle19:"（基于时间的一次性密码）验证器",
        loginTitle20:"扫描二维码",
        loginTitle21:"或",
        loginTitle22:"将'秘钥'输入至您的",
        loginTitle23:"验证器应用程序",
        loginTitle24:"完成设置",
        loginTitle25:"秘钥",
        loginTitle26:"秘钥错误",
        Verify: "验证",
        PleaseUsername: "请输入用户名!",
        Username: "用户名", // user name
        Password: "密码",
        language: "语言",
        PleasePassword: "请输入密码!",
        ForgotPassword: "忘记密码",
        KeepIn: "保持登录状态",
        SignIn: "登录",
        Or: "或",
        RegisterNewAccount: "注册新账户",
        NeedHelpContactAdmin: "需要帮助？请联系系统管理员",
        DonHaveAccount: "还没有帐号?",
        SignUPnow: "注册",
        UserPasswordError: "用户名或者密码错误",
        Cancel: "取消",
        Create: "创建",
        EmailAddress: "邮箱地址",
        VerificationCode: "验证码",
        Pleaseverification: "请输入验证码",
        Sendverification: "发送验证码",
        NewPassword: "新密码",
        passWordError1: "密码长度为8 ~ 64个字符.",
        passWordError2: "",
        passWordError3: "- 一个小写字母",
        passWordError4: "- 一个大写字母",
        passWordError5: "- 一个数字",
        passWordError6: "- 一个符号",
        ConfirmNewPassword: "确认新密码",
        PleaseConfirmPassword: "确认密码",
        TwopasswordsInconsistent: "两次输入的密码不一致!",
        RegistrationSuccess: "注册成功", // 注册成功
        VerificationAddress: "请点击发送验证码",
        Submit: "提交",
        NoUserExists: "用户不存在",
        CaptchaError: "验证码错误",
        CaptchaVerified: "验证成功",
        emailError:"电子邮件地址无效。",
        authenticationFailure:"身份验证失败",
        SsoAccountMismatch:"微软账号与输入的账号不一致，请重新登录。",
        OldPassword: "旧密码",
        NewpasswordNotoldPassword: "新密码不允许与旧密码相同  ",
        OriginalPasswordError: "旧密码错误 !",
        ResetPassword: "修改密码",
        firstLoginChangePassword: "首次登陆，请修改密码",
        registerForm: "注册表单",
        UserAlreadyExist: "用户已存在 !",
        ResetAliasName: "修改别名",
        ChangeAliasName: "修改别名",
        dashboardPortal:"仪表板门户",
        signOut:"登出",
        view:"查看",
        previous:"上一个",
        noReportIsSetupForThisAccount:"此账户未设置报告",
        PasswordExpiryWarning: "密码过期提醒",
        PasswordExpiryMessage: "您的密码即将过期。",
        PasswordExpiredToday: "您的密码今天过期！",
        PasswordExpiryDaysLeft: "您的密码将在 {days} 天后过期。",
        PleaseChangePasswordImmediately: "请立即修改密码以避免账户被锁定。",
    },
    batchReceive: {
        BatchReceive: "批量收货",
        Query: "查询",
        Accept: "接收",
        All: "所有",
        Received: "收货",
        NotReceive: "未收货",
        ReceiveLocation: "收货库位",
        EnterWordsQuery: "输入4个以上的字母进行查询",
        EXPQty: "预期数量",
        RCVQty: "收货数量",
        RCVQtyEA: "收货数量 EA",
        TOID: "TOID",
        RCVLOC: "收货库位",
        EXPIRYDATE: "有效日期",
        Descr: "描述",
        SKU: "商品",
        UDF1: "UDF1",
        UDF2: "UDF2",
        UDF3: "UDF3",
        ReceiveRequired: "收货库位必填",
        RCVQtyCheck: "收货数量需要大于 0.",
        RCVQtyGtExpQty: "收货数量不能大于 预期数量.",
        Status: "状态",
        Line: "行号",
        RecDate: "收货日期",
        LocationCode: "库位编号",
        RecQty: "收货数量",
        RecBaseQty: "收货数量",
        DamageQty: "破损数量",
        DamageBaseQty: "破损数量",
        HoldQty: "冻结数量",
        HoldBaseQty: "冻结数量",
        Remarks: "备注",
        Desc:"详情",
        ProductType: "产品类型",
        ASNQty: "ASN 数量",
        ASNBaseQty: "ASN 数量",
        UOM: "单位",
        PackageQty: "打包数量",
        ManufactureDate: "加工日期",
        ExpiryDate: "有效期",
        ShelfDate: "上架日期",
        PalletID: "托盘 ID",
        CartonID: "纸箱 ID",
        TraceID:"跟踪 ID",
        Article: "Article",
        NotAllowToOverReceive: "不允许超收.",
    },


    reportSetting: {
        DevName: "Dev Name",
        ReSQL: "Re-generate SQL",
        ColumnDetail: "Column Detail",
        ReportType: "Report Type",
        ReportVersion: "Report Version",
        EnglishName: "English Name",
        SimplifiedCNName: "Simplified CN Name",
        TraditionalCNName: "Traditional CN Name",
        EnglishTipsName: "English Tips Name",
        SimplifiedCNTipsName: "Simplified CN Tips Name",
        TraditionalCNTipsName: "Traditional CN Tips Name",
        DisplaySeq: "Display Seq",
        CalculateType: "Calculate Type",
        CustCode: "Cust Code",
        CustName: "Cust Name",
        ProjectCode: "Project Code",
        ProjectName: "Project Name",
        Beautify: "Beautify",
        Verify: "Verify",
        Generate: "Generate",
        Version: "Version",
        Assign: "分配",
        AssignName: "分配人",
        CopyFromMaster: "Copy from Master",
        plInpuSku: "Please input SKU",
        BatchSave: "Batch Save",
        SelectAllforSearchable: "Select All for Search",
        SelectAllforDisaplyable: "Select All for Display",
        importTemplate: "Import Template",
        Upload: "上传",
        Clone: "克隆",
        importConfig: "配置",
        importColumn: "标题字段",
        Mapping: "映射字段",
        Uniquekey: "是否唯一",
        DefaultType: "默认类型",
        DataType: "数据类型",
        Datalength: "数据长度",
        
        DecimalalPlace: "保留小数位",
        DateTimeFormat: "时间格式",
        StartPosition:"开始位置",
        EndPosition:"结束位置",
        Delimiter:"分隔符",
        ReferenceKey:"Reference Key",
        RangeValue:"范围值",
        DefaultValue: "默认值",
        Mandatory: "是否必填",
        CombineFields: "复制字段",
        UploadConfig : "上传配置",
        FileType:"文件类型",
        Delimilter: "Delimilter",
        DelimiterDesc:"默认为“/”, “null” 没有分割符,“Blank” 空格",
        CloneTemplate: "克隆模板",
        TableColumn: "表 字段",
        OperationRule: "操作模式",
        withHeader: "含标题行",
        excelStartRow:"数据起始行",
        isPrintReport:"打印报表",
        printReportCode:"打印报表编号",
      },

    soPage:{
        PackedFirst:"不允许打印，请先打包!",
        inputAllQty:"请输入分配数量!",
        labelCreateDhlShipmentId: "新建 DHL Shipment ID",
        labelAddOrderToShipmentId: "添加订单到 Shipment ID",
        labelShipmentReference: "Shipment Reference",
        labelConfirm: "确认",
        labelQuery:"查询",
        msgShipmentReferenceIsNull: "Shipment Reference 不能为空",
    },
  asnPage:{
    mustPutaway:"状态必须为上架!",
    filesMaxSize:"上传文件总大小不能超过500M!",
    UploadPhoto: "上传图片",
    saveData:"您还没有修改数据!",
    saveHeaderPlease:"请先保存表头数据!",
    pleaseSelectTargetProject: "请选择目标项目。",
    targetProjectNotExist: "目标项目不存在！",
    changeWhProjectTitle: "变更仓库/项目",
    changeWhProjectLabel: "仓库/项目",
  },
    job:{
        Name:"Job名称",
        Class:"Job对应的类",
        Remark:"备注",
        Type:"Job类型",
        ParamName:"参数名",
        ParamValue:"参数值",
        Seq:"序号",
        Add:"新增",
        Save:"保存",
        Run:"执行",
        Delete:"删除",
        Reset:"重置",
        Query:"查询",
        Total:"总共",
        Records:"条记录",
        notNull:"不能为空!",
        Activate:"启用",
        Inactivate:"停用",
        Action:"动作",
        Status:"状态",
        Expression:"表达式",
        BusinessType:"业务系统类型",
        StartTime:"启动时间",
        ActionNo:"动作编号",
        CreateExpression:"生成表达式",
        DateTime:"日期格式",
        Year:"年",
        Month:"月",
        Day:"日",
        Hour:"时",
        Minute:"分",
        Second:"秒",
        StatusCanNotDel:"启用状态不允许删除!",
        ExpressionNotCorrect:"表达式错误!",
        TriggerStatus:"触发器状态",
        PrevFireTime:"上次执行时间",
        NextFireTime:"下次执行时间",
    },
    wine: {
        AvailableQty: "輸入數量超出有效庫存數量!",
        inputEnglish:"只能输入英文",
        inputChinese:"只能输入中文",
        maxCharacters:"最大.{0}位",
        mustInputChinese:"如果没有填写英文地址,则中文地址必填.",
    },
    printLabel:{
        NumberOfQrCodeLabelRequired: "Number of QR Code Label Required",
        NumberOfRelIdLabelRequired: "Number of Rel Id Label Required",
        labelType:"Label Type",
        qrCodeLabel:"Pre-Print Label",
    },
    cfs:{
        OrderCancel:"订单拦截",
        operationSuccess:"操作成功",
        orderNo:"订单编号",
        loadingNo:"装箱单号",
        platformOrderNo:"Platform Order No",
        parcelNo:"条码",
        unScanQty:"未扫描数量",
        invoiceFlag:"Print Label / Invoice Flag",
        scannedQty:"已扫描数量",
        parcelNoTrackingNo:"Parcel No. / Tracking No.(Last Mile Label)",
        trackingNo:"Tracking No.(Last Mile Label)",
        destinationCountry:"Destination Country",
        courier:"Courier",
        parcelNotOrder:"Parcel not belong to this order",
        printLabel:"Print Label",
        printDhlInvoice:"Print DHL Commercial Invoice",
        scanLoad:"扫描装箱",
        awbMbl:"AWB / MBL / Tracking No",
        uldNo:"Container No. / ULD No.",
        collectionTimeFrom:"Collection Time From",
        collectionTimeTo:"Collection Time To",
        createLoading:"创建装箱单",
        confirmLoading:"装箱确认",
        ediSendFlag:"EDI Send Flag",
        resetFirst:"Please reset.",
        noOfDestinationLabelRequired:"No. of Destination Label required",
        orderNumber:"运单号",
        barcode:"条码",
        damage:"损坏",
        dimensions:"尺寸",
        nextOrder:"下一个订单",
        delete:"删除",
        printViewPdf: "打印箱贴",
    },
    support:{
        org:"Org",
        project:"Project Name",
        a01ReopenASNAsn:"ASN#",
        note:"Note",
        submit:"Submit",
        reset:"Reset",
        c01MovePOToWarehousePO:"PO#",
    },
    printerConfig: {
        refresh:"刷新打印机列表",
        servicesName:"服务器名称",
        ip:"IP地址",
        printerName:"打印机名称",
    },
    scanPack:{
        orderNoRequired: '订单号不允许为空',
        cancelCheckCompleteMsg:'确认移除所有包装好的纸箱?',
        cancelCheckCompleteMoveMsg: '是否将所有取消的库存移回原始位置?',
        cancelPickForCheckCompleteMsg: '以下SKU已拣货但未装箱，是否确认取消拣货?',
        cancelCheckCompleteNo:'否',
        cancelCheckCompleteYes:'是',
        title: '确定',
        currentScanQty:'当前扫描数量',
        deletePickingData:"确认删除拣货数据吗",
        firstCancelCheckCompleteThenScanPack:"当前订单存在部分复核完成,是否取消复核完成",
        antiCounterfeitingCodePleaseConfirm:"非出库防伪码，请确认",
        currentBrand:"当前品牌",
        getExpressNumber:"获取快递单号",
        ssccAlreadyUse:"SSCC#{0} 不允许混合包装订单",
        scanByWave:"请使用 波次ID ( {0} )扫描",
        notAllowedBatchClose: "当前装箱数据未提交，不允许批量关箱"
    },
    skuSearch:{
      skuSearch: "商品搜索",
      upcSearch: "UPC 搜索",
      sku: "商品码",
      multipleSku: "批量商品码",
      skuFrom: "起始商品码",
      skuTo: "结束商品码",
      search: "搜索",
      skuCode: "商品码",
      skuDesc: "商品描述",
      upc: "商品条码",
      style: "款式",
      color: "颜色",
      size: "尺寸"
    },
    invTrans:{
        transType:"事务类型",
        transStatus:"事务状态",
        orderNo:"单证号",
        transTimeFrom:"事务时间从",
        transTimeTo:"事务时间到",
        systemUser:"系统人员",
        lotAttribute:"批次属性",
        ownerCode:"货主",
        lotNo:"批号",
        id:"跟踪号",
        back:"返回",
        transId:"事务编号",
        transTime:"事务时间",
        lineNo:"行号",
        transactionTime:"交易日志时间查询必须是{0}天內的查询!",
        operator:"操作人",
        ownerCodeFrom:"货主从",
        ownerCodeTo:"货主到",
        skuFrom:"商品从",
        skuTo:"商品到",
        skuDescFrom:"商品名称从",
        skuDescTo:"商品名称到",
        lotNoFrom:"批次号从",
        lotNoTo:"批次号到",
        idFrom:"跟踪号从",
        idTo:"跟踪号到",
        locFrom:"库位从",
        locTo:"库位到",
        qtyFrom:"数量从",
        qtyTo:"数量到",
        unitQtyFrom:"单位数量从",
        unitQtyTo:"单位数量到",
        uomFrom:"单位从",
        uomTo:"单位到",
        descriptionFrom:"描述从",
        descriptionTo:"描述到",
        amount:"金额",
        typeMustBeSelected:"必须选择操作类型",
        pleaseSelectAQueryPeriod:"请选择查询时间段",
    },
    currency:{
        currency:"货币",
        description:"描述",
        currencySymbol:"货币符号",
    },
    billingMaintance: {
        add:"新增",
        query:"查询",
        reset:"重置",
        edit:"编辑",
        billId:"账单号",
        cutOffFrom:"截止时间",
        billingPeriodFrom:"计费开始时间",
        billingPeriodTo:"计费结束时间",
        confirmDate:"确认日期",
        postDate:"发布日期",
        invoiceNo:"发票号",
        invoiceDate:"发票日期",
        billToName:"收件人",
        billToAddress1:"地址1",
        billToAddress2:"地址2",
        billToAddress3:"地址3",
        billToAddress4:"地址4",
        billToCity:"市",
        billToProvince:"省",
        billToCountry:"国家",
        billToZip:"邮编",
        billToContactName:"联系人",
        billToContactPhone:"联系电话",
        billToContactFax:"传真",
        billToContactEmail:"邮件",
        currency:"货币",
        exchangeRate:"汇率",
        lineNo:"行号",
        chargeMethod:"费用方法",
        tariffId:"税率",
        chargeCode:"费用",
        description:"描述",
        billDateFrom:"账单开始时间",
        billDateTo:"账单结束时间",
        billType:"账单类型",
        billBase:"账单基础",
        billUnit:"单位",
        overflowCharge:"溢出费用",
        accountCode:"账户",
        localExchangeRate:"当地汇率",
        baseAmount:"基础金额",
        localAmount:"本地金额",
        totalAmount:"总金额",
        invoiceLineSeq:"发票行号",
        CreateMaintance:"创建",
        EditMaintance:"编辑",
        PleaseinputBillId:"请输入账单号",
        msgBillingPeriodFromLessThanTo:"计费开始时间小于计费结束时间",

    },
    resPlan:{
      workingDayOnly:"只适用于工作日",
      waveIdNotnull:"波次号不能为空",
      needCreateResourcePlan:"是否需要创建Resource Planning?",
    },
    cycleCount:{
        Location: "库位编号",
        createTicket: "创建票数",
        includeStatus: "包含状态",
        reCount: "重新计数",
        numberOfSplit: "拆分次数",
        confirmToCreateTicketForLocation:"是否确认开始或再次盘点以下包括盘点记录外的库位？",
        confirmToReCountLocation:"是否确认再次盘点库位？"
    },
    handheldConfiguration:{
        handheldConfiguration:"手持式配置",
        handheldApplicationConfiguration:"手持机应用配置",
        configName:'配置名称',
        relatedFunction:'相关功能',
        status:'状态',
        flowSetting:'流动设置',
        orderSearch:'订单查询',
        scanning:'扫描',
        haveSearchScreen:'是否搜索画面?',
        scanName:'扫描名称',
        promptMessage:'提示信息',
        actionSettings:'行动设置',
        action:'行动',
        targetField:'目标字段',
        field:'字段',
        stepSettings:'步骤设置',
        new: "新",
        value:'值',
        type:'类型',
        length:'长度',
        dataLength:'数据长度',
        relatedSettings:'相关设置',
        lockValue:'查找值?',
        displayIn:'显示在?',
        showCurrProgress:'显示当前进度',
        showSummary:'显示总结',
        info:'信息',
        showConfDialog:'显示配置对话框',
        displayText:'展示文本',
        changeCommand:'改变命令',
        last:'(最新)',
        completeOnCloseNext:'关闭/下一个 完成?',
        suggestLocation:'建议库位?',
        dialogSettings:'对话框设置',
        input:'输入',
        mandatory:'Mandatory',
        dimension:'必填',
        volume:'体积',
        grossWeight:'毛重',
        netWeight:'净重',
        logicSettings:'逻辑设置',
        use:'使用',
        priority:'优先权',
        lastLocation:'最新库位',
        nextEmptyLocation:'下一个空库位',
        pickLocation:'拣货库位',
        storageLocation:'存储库位',
        closeToSameSku:'关闭相同的sku',
        matchItemType:'匹配相同类型',
        useProjectLocation:'使用项目库位',
        useWarehouseLocation:'使用仓库库位',
        scanSingle:'单行扫描?',
        displayInformation:'显示信息',
        scanningScanNameCannotBeEmpty:'扫描 {0} 扫描名称不能为空.',
        orderSearchScanNameCannotBeEmpty:'订单查询扫描名称不能为空.',
    },
    cycleCountMaster:{
        belowLocationAndSku:"以下位置和SKU有分配数量/持有数量，您确定要忽略它们来创建盘点订单吗？",
        belowSkuCreateCountOrder:"以下SKU包含已分配数量。确认在不包含它们的情况下创建盘点订单？",
        quantityNeedsToBeGreaterThan0:"数量需要大于 0",
        createCountOrderByNumber:"按默认计数次数创建盘点单?",
        countOrderCompleteOrder:"库存盘点 {0} 及其相关票证仍在处理中\n" +
            "您是否希望关闭未结清的交易并完成库存盘点?",
    },
    confirmDeleteLoading:"订单已经装车,确认要从装车单中移除吗?",
    expDeliveryDateNotnull:"预计发货日期不能为空!",
    scanIn:"收货扫描",
    carrier:"承运人",
    flightNo:"航班号",
    parcelUnWeighed:"包裹未称重",
    airLine:"航空公司",
    arrivedTime:"到港时间",
    shipFrom:"发货地",
    shipTime:"起飞时间",
    services:"服务",
    servicesProvider:"服务商",
    gatewayCannotBeEmpty:"Gateway不能为空",
    serviceCannotBeEmpty:"服务不能为空",
    serviceProviderCannotBeEmpty:"服务商不能为空",
    skynetPostal:"邮政渠道",
    battery:"电池",
    batteryCannotBeEmpty:"电池不能为空",
    copyLoading:"复制装箱单",
    showAll:"展示所有",
    processActionMsg:"是否确认此操作?",
    orderRef: "订单号",
    printNotConnected: "打印机连接失败",
    notLabelRecord:"未找到记录",
    collarBarcode:{
        woolenCollarBarcode:"毛领子条码",
        woolenCollarBarcodeMismatch:"毛领子条码不匹配",
        missing:"缺失",
    },
    soStatus:{
        partialAllocated:"部分分配",
        allocation:"分配",
        partialPicked:"部分拣货",
        picked:"完全拣货",
        partialPacked:"部分装箱",
        packed:"完全装箱",
        partialLoaded:"部分装车",
        loaded:"完全装车",
        partialShipped:"部分发运",
        shipped:"完全发运",
        delivered:"递送",
        billed:"账单",
        cancelled:"订单取消",
        deleted:"删除",
        closed:"订单完成",
    },
    asnStatus:{
        partialReceived:"部分收货",
        received:"完全收货",
        partialPutaway:"部分上架",
        putaway:"完全上架",
        cancelled:"取消状态",
        deleted:"删除状态",
        closed:"关闭状态",
    },
    conditionCycleCount:{
        locationCode:"库位编码",
        locationType:"库位类型",
        locationName:"库位名称",
        zone:"库区",
        storageType:"存储类型",
        noDataMsg:"没有数据被选,将会生成所有数据,确定继续吗?",
        SearchTitle: "库位查询，(如不需要指定库位或者SKU,请点击[创建]按钮)",
        create: "创建"
    },
    loading:{
        loadId:"装车ID",
        container:"装车号",
        hidden: "隐藏",
        searchCartonByWave:"按波次搜索箱",
        importSscc:"导入SSCC",
        seal:"密封号",
        containerType:"装车类型",
        vesselFight:"轮船",
        voyage:"航线",
        mbl:"MBL",
        hbl:"HBL",
        driver:"驾驶员",
        etd:"预计离开时间",
        eta:"预计到达时间",
        portOfLoading:"装货港",
        portOfDischarge:"卸货港",
        portOfDestination:"目的港",
        loadFrom:"装车开始时间",
        loadTo:"装车结束时间",
        remarks:"备注",
        loadedCartonQty:"装车箱数量",
        detailSearch:"详细信息搜索",
    },
    filterBy:"筛选",
    allocationResults: "分配结果",
    importResults:"导入结果",
    lastestNotifications:"最近{0}条通知",
    todayNotifications:"今天的通知",
    yesterdayNotifications:"昨天的通知",
    success:"成功",
    failed:"失败",
    inputNumCharsThenPressEnter:"请输入{0}个或以上字符后按<enter>",
    queryCondition:"查询条件",
    thaiName:"泰语",
    japaneseName:"日语",
    headerJoinFieldName:"主关联字段",
    detailJoinFieldName:"明细关联字段",
    queryFieldName:"查询字段",
    compareType:"比较类型",
    fixedValue:"固定值",
    todayDate:"当天日期",
    pageType:"控件类型",
    codeMasterGroup:"数据字典组",
    queryTable:"字段所属表",
    headerTable:"主关联表",
    detailTable:"明细关联表",
    splitScan: {
        queryConditionCantBeNull: "查询条件不能为空",
        skuCannotBeEmpty: "商品编码不能为空",
        noUnreviewedProductsExist:"不存在未复核商品",
    },
    stdBalanceReport:{
        brand: "品牌",
        size: "尺寸",
        volume:"单个体积m³",
        totalVolume:"总体积m³",
        minRecDate: "原始入库时间",
        department:"部门",
        sku:"商品",
        skuName:"品名",
        material:"物料款号/代码",
        specification:"规格",
        keyword: "模糊",
        units:"单位",
        qty:"数量",
        inboundTime:"最近入库时间",
        outboundTime:"最近出库时间",
        period:"时期",
        remark:"备注/描述",
        Location:"库位",
        prePicture:"图片预览",

    },
    sessionModal: {
        title: "登录已过期",
        message: "由于长时间未操作，请重新登录",
        passwordChangedMessage: "密码已修改，请重新登录",
        username: "用户名",
        password: "密码",
        loginButton: "登录",
        logoutButton: "退出",
        usernameRequired: "请输入用户名和密码",
        passwordRequired: "请输入密码",
        loginFailed: "登录失败，请检查用户名和密码",
        loginError: "登录失败，请重试",
        loginSuccess: "重新登录成功",
        loginLoading: "登录中...",
        loginTimeout: "请求超时，请重试",
        securityTitle: "安全警告",
        securityMessage: "检测到未授权的数据修改，为了您的安全请重新登录",
        securityWarning: "为了您的安全，请验证您的身份",
        tokenExpiredMessage: "会话已过期，请重新登录",
        tokenInvalidMessage: "登录凭证无效，请重新登录",
        noPermissionTitle: "无权限",
        noPermissionMessage: "您没有权限访问该资源",
        okButton: "确定",
        projectChangedTitle: "项目已变更",
        projectChangedMessage: "当前项目已发生变化，请刷新页面以加载正确的项目数据",
        reloadButton: "刷新页面",
    },
    pack: "装箱",
    summary: "汇总",
    searchByOrder: "按订单搜索",
    pieceScanMode: "单品扫描模式",
    materialsScanMode: "物料扫描模式",
    cartonScanMode: "纸箱扫描模式",
    manualQtyEntry: "手动输入数量",
    scanRemoveMode: "扫描移除模式",
    pcsPerScan: "单次扫描件数",
    scan: "扫描",
    scanBarcodeHere: "在此扫描条码",
    scanCartonHere: "在此扫描纸箱",
    scanMaterialsHere: "在此扫描物料",
    newCarton: "新建纸箱",
    deleteCarton: "删除纸箱",
    closeCarton: "关闭纸箱",
    showOutstandingData: "显示未完成数据",
    removeQuantity: "移除数量",
    piecesToRemove: "待移除件数",
    enterQuantity: "输入数量",
    piecesToAdd: "待添加件数",
    open: "开启",
    closed: "已关闭",
    notFoundMaterial: "未找到物料：",
    order: "订单",
    uploadScanningFile: "上传扫描文件",
    printDoc: "打印单据",
    packingInstructions: "装箱说明",
    vasInstructions: "增值服务说明",
    currentCarton: "当前纸箱",
    pcs: "件",
    totalCartons: "总纸箱数",
    createCartonFirstScanning: "请先创建纸箱再开始扫描",
    orderInformation: "订单信息",
    tracking: "物流单号",
    orderItems: "订单商品",
    complete: "完成",
    cartonManagement: "纸箱管理",
    cartonDetails: "纸箱详情",
    cartonSize: "纸箱尺寸",
    extraInformation: "附加信息",
    itemsInCarton: "纸箱内商品",
    noItemsScanned: "尚未扫描任何商品",
    materialsInCarton: "纸箱内物料",
    noMaterialsScanned: "尚未扫描任何物料",
    packingSummary: "装箱汇总",
    totalOrders: "总订单数",
    totalSKUs: "总SKU数",
    totalPacked: "总装箱数",
    scanTraceIdHere:"在此扫描周转箱",
    traceIdScanMode:"周转箱扫描模式",
    cm:"厘米",
    kg:"千克",
    isFarfetchReturnRefundShippingCost:"发发奇退货是否退运费?",
    dontInputSkuScanBarcode:"不要输入SKU.请扫描条形码.",
    innerQtyMustEqualPackQty:"内袋物料数量必须等于打包数量",
    outerQtyAtLeastOne:"至少有一件外包装物料",
    projectQueryList:"项目查询列表",
    defaultQueryList:"默认查询列表",
    hide:"隐藏",
    show:"显示",
    copyToProjectList:"复制到项目查询列表",
    copyToAnotherLanguage:"复制到其他语言",
    copyToAnotherProject:"复制到其他项目",
    copyTo:"复制到",
    DueDateUpdateConfirm:"以下波次已包含扫描包截止日期。确认更新吗？",
    domain:"域",
    singleSignOn:"单点登录",
    countedQty:"统计数量",
    packFactor:"包装系数",
    importMsg:"导入信息",
    uploadTime:"上传时间",
    AreYouImportTask: "您确定导入所选记录吗？",
    countDateFrom:"日期从",
    countDateTo:"日期到",
    selectOfflineCountResult:"选择离线盘点结果",
    po:"采购单",
}
